const REVIEWS_THRESHOLD_TO_BE_SHOWN = 1;

export default REVIEWS_THRESHOLD_TO_BE_SHOWN;
